import { useState } from 'react'
import { useSnackbar } from 'notistack'

import { DGEImportLicensesPreviewResponse } from '@img-arena/consoles-api-streaming'
import { Alert, Stack } from '@mui/material'
import { DragDropFileUpload } from '@/components/inputs/DragDropFileUpload'
import { streamingRestApi } from '@/service/streamingApi'

type Data = {
  operatorId: number
}

export type ImportLicensesPreviewStepProps = {
  onPreviewData: (data: DGEImportLicensesPreviewResponse) => void
  data: Data
}

export const ImportLicensesPreviewStep = ({
  onPreviewData,
  data
}: ImportLicensesPreviewStepProps) => {
  const { enqueueSnackbar } = useSnackbar()

  const [isUploading, setIsUploading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleFileSelect = async (file: File) => {
    setError(null)
    setIsUploading(true)

    try {
      if (!data || !data.operatorId) {
        throw new Error('Operator ID is required')
      }

      const response = await streamingRestApi.endpoints.operators.importLicensesPreview(
        data.operatorId,
        file
      )

      onPreviewData(response.data)
      enqueueSnackbar('File uploaded successfully', { variant: 'success' })
    } catch (error) {
      const errorMessage = 'Failed to upload file'
      setError(errorMessage)
      enqueueSnackbar(errorMessage, { variant: 'error' })
    } finally {
      setIsUploading(false)
    }
  }

  return (
    <Stack direction="column" spacing={3}>
      <DragDropFileUpload
        onFileSelect={handleFileSelect}
        accept=".csv"
        maxSize={5}
        loading={isUploading}
        testId="license-file-upload"
      />

      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </Stack>
  )
}
